<template>
  <v-card
    flat tile
    style="width: 100%"
    elevation="1"
    class="transport"
  >
    <v-card-actions>
      <h4 class="pl-4 subtitle-2">{{ title }}</h4>
      <v-spacer />
      <v-btn icon @click="showMore = !showMore" >
        <v-icon>{{ showMore ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
      </v-btn>
    </v-card-actions>
    <v-divider />

    <v-expand-transition >
    <v-card-text v-show="showMore" class="grey lighten-4" >

      <div v-if="items && items.length" class="pb-4">
        <div
          v-for="item in items"
          :key="item.id"
          class="facet-item"
          :class="isChecked(item.id) ? 'facet-item--selected' : ''"
          style="padding: 0.1rem 0.5rem;"
        >
          <label class="d-flex align-center" :title="item.value">
            <input class="mb-1" @click="handleFilterClick($event, item)" type="checkbox" :checked="isChecked(item.id)" />
            <span v-if="getDefaultValueLabel(item.value)" class="mx-1 ellipsis">{{ getDefaultValueLabel(item.value) }}</span>
            <span class="caption counter ml-auto">{{ item.count }}</span>
          </label>
        </div>
      </div>
      <div v-else class="caption grey--text text--darken-2">
        Aucun résultat trouvé ...
      </div>

      <v-divider />
      
      <v-row class="pt-1">
        <v-col class="px-4">
          <v-range-slider
            v-model="range"
            :max="max"
            :min="min"
            hide-details
            class="align-center"
          >
            <template v-slot:prepend>
              <v-text-field
                :value="range[0]"
                hide-details
                single-line
                type="number"
                style="width: 20px"
                class="text-subtitle-2 pt-0"
                @change="$set(range, 0, $event)"
              ></v-text-field>
            </template>
            <template v-slot:append>
              <v-text-field
                :value="range[1]"
                hide-details
                single-line
                type="number"
                style="width: 20px"
                class="text-subtitle-2 pt-0"
                @change="$set(range, 1, $event)"
              ></v-text-field>
            </template>
          </v-range-slider>
        </v-col>
      </v-row>
      <v-card-actions class="justify-center">
        <v-btn class="red white--text text-subtitle-2" @click="handleFilterClick">Valider</v-btn>
      </v-card-actions>
    </v-card-text>
    </v-expand-transition>
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    field: String,
    type: String,
    show: {
      type: Boolean,
      default: false
    },
    items: Array,
    defaultValueLabels: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      range: [
        this.$store.state.filters.find(filter => filter.id === `${this.field}-rangeSlider`)?.from || 1,
        this.$store.state.filters.find(filter => filter.id === `${this.field}-rangeSlider`)?.to || 30
      ],
      min: 1,
      max: 30, 
      showMore: this.show
    };
  },
  methods: {
    updateSlider() {
      this.range[0] = Math.max(this.min, this.range[0]);
      this.range[1] = Math.min(this.max, this.range[1]);
    },
    handleFilterClick(event, item) {
      if(item){
        this.$store.commit("removeFilter", { id: `${this.field}-rangeSlider` });
        if(event.target.checked){
          this.$store.commit("setFilter", {
            field: this.field,
            value: item.value,
            id: item.id,
            defaultValueLabel: this.getDefaultValueLabel(item.value),
            type: this.type
          });
        } else {
          this.$store.commit("removeFilter", { id: item.id });
        }
      }else{
        this.$store.commit("removeFilter", { id: `${this.field}-rangeSlider` });
        for(item of this.items) this.$store.commit("removeFilter", { id: item.id });
          
        this.$store.commit("setFilter", {
            field: this.field,
            from: Math.max(this.min, this.range[0]) || null, 
            to: Math.min(this.max, this.range[1]) || null, 
            breadcrumbs: true,
            title: this.title,
            id: `${this.field}-rangeSlider`,
            type: "range",
            fieldType: "rangeSlider"
          });
        }
      },
      isChecked(id) {
      let filter = this.$store.state.filters.find(f => f.id === id);
      return !!filter
      },
      getDefaultValueLabel(value) {    
        if (!this.defaultValueLabels) return value;
    
        return (value in this.defaultValueLabels) ? this.defaultValueLabels[value] : value;
      }
  },
  watch: {
    showMore() {
      this.$emit('show-changed');
    }
  }
};
</script>